import { render, staticRenderFns } from "./upload-file.component.vue?vue&type=template&id=2c86c1d1&scoped=true"
import script from "./upload-file.component.vue?vue&type=script&lang=ts"
export * from "./upload-file.component.vue?vue&type=script&lang=ts"
import style0 from "./upload-file.component.vue?vue&type=style&index=0&id=2c86c1d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86c1d1",
  null
  
)

export default component.exports